import { useFeature, useGrowthBook } from '@growthbook/growthbook-react';
import { useRef } from 'react';

export type FactorTrustUiGroup = { isTrustUi: boolean; abGroup: 'trust_ui' | 'control' | null };

/**
 * A/B group of the online-visit invoice trust UI (GrowthBook `factor-v2-trust-ui`, 50% rollout on `id`
 * = terminal_id). Decided once per invoice view and locked: the page never flips variant if the
 * terminal id / flags arrive later. Without a terminal id at decision time (a first-ever visit whose
 * cookie is not set yet) the patient sees the control UI and is left out of the experiment (abGroup null).
 */
export const useFactorTrustUiGroup = (): FactorTrustUiGroup => {
  const growthbook = useGrowthBook();
  const feature = useFeature('factor-v2-trust-ui');
  const locked = useRef<FactorTrustUiGroup | null>(null);

  if (!locked.current && feature.source !== 'unknownFeature') {
    const hasId = !!growthbook?.getAttributes()?.id;
    locked.current = hasId
      ? { isTrustUi: feature.on, abGroup: feature.on ? 'trust_ui' : 'control' }
      : { isTrustUi: false, abGroup: null };
  }
  return locked.current ?? { isTrustUi: false, abGroup: null };
};
